import { render, staticRenderFns } from "./modalEliminarImagen.vue?vue&type=template&id=747dc124"
import script from "./modalEliminarImagen.vue?vue&type=script&lang=js"
export * from "./modalEliminarImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports